import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { Tooltip } from 'ui-components/components/tooltip';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { messages } from '../../containers/orders-reusable-grid-button-container/messages';
import Global from '../../store/global-selectors';
import { MarketplaceIds } from '../../enums/marketplace-ids';
import { emptyArray } from 'ui-components/default-props/empty';
import style from './cancelled-indicator.module.less';

const CancelledIndicator = ({ restore, fulfillmentPlanId }) => {
  const [isRestoring, setIsRestoring] = useState(false);
  const salesOrderIds =
    useSelector((state) =>
      Global.selectEntitiesSalesOrderIdsByFulfillmentPlanIds(state, {
        fulfillmentPlanIds: [fulfillmentPlanId],
      }),
    ) || emptyArray;
  const salesOrders = useSelector((state) => Global.selectEntitiesSalesOrdersByIds(state, { salesOrderIds })) || emptyArray;
  const [salesOrder] = salesOrders;
  const isRejectedFulfillment = salesOrder && salesOrder.store.marketplaceId === MarketplaceIds.AuctaneFulfillment.toString();

  const onRestore = useCallback(() => {
    setIsRestoring(true);
    restore(fulfillmentPlanId);
  }, [setIsRestoring, restore, fulfillmentPlanId]);

  return (
    <div className={style.wrapper}>
      <div className={style.header}>
        <FormattedMessage defaultMessage='This Shipment is Cancelled' description='ordersDrawer.cancelledIndicator.header' id='6DW6OU' />
      </div>
      <Tooltip
        position='bottom'
        shouldHideTooltip={!isRejectedFulfillment}
        text={<FormattedMessage {...messages.orderReusableGridRestoreDisabledTooltip} />}
      >
        <div>
          <FormattedMessage defaultMessage='Restore' description='ordersDrawer.cancelledIndicator.restore' id='OAY4C5'>
            {(buttonText) => {
              return (
                <Button disabled={isRestoring || isRejectedFulfillment} onClick={onRestore} theme='primary'>
                  {buttonText}
                  {isRestoring && (
                    <div className={style['loading-indicator-wrapper']}>
                      <LoadingIndicator theme='white' />
                    </div>
                  )}
                </Button>
              );
            }}
          </FormattedMessage>
        </div>
      </Tooltip>
    </div>
  );
};

CancelledIndicator.propTypes = {
  restore: PropTypes.func.isRequired,
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default CancelledIndicator;
